var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00033 22H19.0003M2.50033 8H21.5003M10.0003 2L8.00033 8L12.0003 18.5L16.0003 8L14.0003 2M12.5923 18.3489L21.5319 8.5153C21.6979 8.33264 21.781 8.24131 21.814 8.13732C21.8432 8.04569 21.8453 7.94759 21.8201 7.85478C21.7916 7.74946 21.7125 7.65465 21.5545 7.46501L17.2402 2.28785C17.152 2.18204 17.108 2.12914 17.0539 2.09111C17.006 2.05741 16.9526 2.03238 16.896 2.01717C16.8322 2 16.7634 2 16.6256 2H7.37503C7.2373 2 7.16844 2 7.10462 2.01717C7.04808 2.03238 6.99465 2.05741 6.94676 2.09111C6.89272 2.12914 6.84863 2.18204 6.76046 2.28785L2.44616 7.46501C2.28813 7.65464 2.20911 7.74946 2.18054 7.85478C2.15535 7.94759 2.15747 8.04569 2.18662 8.13732C2.21971 8.24131 2.30273 8.33264 2.46879 8.51529L11.4084 18.3489C11.6136 18.5746 11.7162 18.6875 11.8368 18.7292C11.9427 18.7659 12.0579 18.7659 12.1639 18.7292C12.2845 18.6875 12.3871 18.5746 12.5923 18.3489Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond02);
export default __webpack_public_path__ + "static/media/diamond-02.622e7e189ea638780c155d0e4a86b604.svg";
export { ForwardRef as ReactComponent };